import VueRouter from '../router/main';
import _ from '../libs/lodash';
import globalStore from '$$globalStore';

function analyticsWorkload() {
  if (isCommonWorkloadViewRoute()) {
    userExtAnalytics.log('workload_open', { from: 'general' });
  }
}

const changeRoute = (path = '/', query = {}) => {
  if (VueRouter) {
    VueRouter.push({
      path,
      query,
    });
    analyticsWorkload();
  }
};

const pushRoute = route => {
  if (VueRouter) {
    VueRouter.push(route);
    analyticsWorkload();
  }
};

const pushByNameAndParams = (name = 'app', params = {}) => {
  if (VueRouter) {
    VueRouter.push({
      name,
      params: { ...VueRouter.currentRoute.value.params, ...params },
    });
  }
};
const getCurrentRoute = () => VueRouter.currentRoute.value;
const pushQuery = query => {
  changeRoute(getCurrentRoute().path, query);
};

const isGanttRoute = () => VueRouter.currentRoute.value.path.includes('/gantt');

const isGanttGridRoute = () => {
  const route = VueRouter.currentRoute.value;

  return (route.name === 'project' || route.params.parent === 'project' || isMultiProjectsRoute()) && route.params.mode === 'gantt';
};

const isMultiProjectsRoute = () => {
  const route = VueRouter.currentRoute.value;

  if (globalStore.getters.isExport || globalStore.getters.isLink) {
    return !!route.path?.includes('/projects');
  }

  return (route.name === 'projectsMultiView' || route.name === 'multiviewTaskRoute');
};

const isBoardRoute = () => {
  const route = VueRouter.currentRoute.value;

  return route.params.mode === 'board';
};

const isSingleProjectRoute = () => {
  const route = VueRouter.currentRoute.value;

  return route.name === 'project' || route.name === 'app' || route.params.parent === 'project';
};

const isColumnsSettingsRoute = () => {
  const route = VueRouter.currentRoute.value;

  return route.path === '/settings/columns';
};

const isProfileSettings = () => {
  const route = VueRouter.currentRoute.value;

  return route.path.startsWith('/settings');
};

const isTaskSettingsRoute = (routeToCheck = null) => {
  const route = routeToCheck || VueRouter.currentRoute.value;
  const taskRoutes = ['taskRoute', 'listTaskRoute', 'multiviewTaskRoute', 'workloadTaskRoute'];

  return _.find(taskRoutes, name => name === route.name);
};

const isListViewRoute = () => {
  const route = VueRouter.currentRoute.value;

  return (route.name === 'listView' || route.name === 'listTaskRoute');
};

const isCommonRoute = () => !isSingleProjectRoute() && !isMultiProjectsRoute();

const isProjectList = () => {
  const route = VueRouter.currentRoute.value;

  return ((route.name === 'project' || route.name === 'taskRoute') && route.params.mode === 'list');
};

const isMultiviewList = () => {
  const route = VueRouter.currentRoute.value;

  return ((route.name === 'projectsMultiView' || route.name === 'multiviewTaskRoute') && route.params.mode === 'list');
};

const isTeamRoyte = () => {
  const route = VueRouter.currentRoute.value;

  return route.name === 'teamAndResources';
};

const isWorkloadViewRoute = () => {
  const route = VueRouter.currentRoute.value;

  return (route.name === 'workload' || route.name === 'workloadTaskRoute' || route.params.mode === 'workload');
};

const isCommonWorkloadViewRoute = () => {
  const route = VueRouter.currentRoute.value;

  return (route.name === 'workload' || route.name === 'workloadTaskRoute');
};

const isTrialCompleteViewRoute = () => {
  const route = VueRouter.currentRoute.value;

  return (route.name === 'trialCompleteUser' || route.name === 'trialCompleteOwner');
};

const isNoProjectViewRoute = () => {
  const route = VueRouter.currentRoute.value;

  return route.name === 'noProject';
};

const isExportRoute = () => {
  const route = VueRouter.currentRoute.value;

  return route.params.mode === 'export';
};
const isHistoryRoute = () => {
  const route = VueRouter.currentRoute.value;

  return route.params.mode === 'history';
};

const backRoute = () => {
  VueRouter.back();
};

const analyticsFromRoute = () => {
  let from = '';
  const url = VueRouter.currentRoute.value.path;
  const urlArr = url.slice(1).split('/');
  const urlItems = urlArr.filter(item => !Number.parseInt(item));

  switch (urlItems[0]) {
  case 'project': from = 'project & portfolio'; break;
  case 'projects': from = 'project & portfolio'; break;
  case 'tasks': from = 'my tasks'; break;
  case 'workload': from = 'workload'; break;
  case 'timelog': from = 'my time log'; break;
  case 'team': from = 'team && resourse'; break;
  default: from = urlItems[0];
  }

  return from;
};

const analyticsRoute = () => {
  let route = '';
  const url = VueRouter.currentRoute.value.path;
  const urlArr = url.slice(1).split('/');
  const urlItems = urlArr.filter(item => !Number.parseInt(item));

  switch (urlItems[0]) {
  case 'project': route = `Project/${urlItems[1]}`; break;
  case 'projects': route = `Portfolio/${urlItems[1]}`; break;
  case 'tasks': route = 'MyTasks'; break;
  case 'workload': route = 'Workload'; break;
  case 'timelog': route = 'MyTasks'; break;
  default: route = url;
  }

  return route;
};

export default {
  analyticsRoute,
  analyticsFromRoute,
  isGanttGridRoute,
  changeRoute,
  pushRoute,
  pushQuery,
  getCurrentRoute,
  pushByNameAndParams,
  isGanttRoute,
  isBoardRoute,
  isSingleProjectRoute,
  isColumnsSettingsRoute,
  isTaskSettingsRoute,
  isMultiProjectsRoute,
  isListViewRoute,
  isWorkloadViewRoute,
  isExportRoute,
  isCommonWorkloadViewRoute,
  isTrialCompleteViewRoute,
  isNoProjectViewRoute,
  backRoute,
  isTeamRoyte,
  isMultiviewList,
  isProjectList,
  isProfileSettings,
  isCommonRoute,
  isHistoryRoute,
};
